<script setup>
import { computed } from 'vue';
import { useEventStore } from '@/stores/event/event.store';
import { PageHeader, PageFooter } from '@/components/clients/common';

const props = defineProps({
  mainColor: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
  },
  id: {
    type: Number,
    required: true,
  },
});

const eventStore = useEventStore();

const imageUrl = computed(() => {
  return eventStore.getImages.additionalSites[props.id]
    ? eventStore.getImages.additionalSites[props.id].url
    : '';
});
</script>

<template>
  <div class="background">
    <div class="page">
      <PageHeader :main-color="mainColor" :background-color="backgroundColor" />
      <img class="image" :src="imageUrl" alt="" />
    </div>
    <PageFooter />
  </div>
</template>

<style lang="scss" scoped>
.background {
  background-color: v-bind(backgroundColor);
  width: 100%;
  height: 100%;
}

.page {
  position: relative;
  margin: auto;
  width: 100%;
  min-height: 100vh;
  height: auto;
  background-color: v-bind(backgroundColor);
  max-width: 1200px;
  display: flex;
  justify-content: center;

  .image {
    padding-top: 110px;

    @media screen and (max-width: 768px) {
      padding-top: 70px;
    }
  }
}
</style>
